/* POINTURE SWATCH FIX (2026-09-14) — quand le filtre natif Search & Discovery
   "Pointure" (filter.v.option.pointure, active le 2026-09-14 en Admin) est
   applique sur une page collection, Shopify filtre correctement les produits
   mais ne fixe PAS automatiquement le swatch pointure correspondant sur les
   vignettes — chaque fiche reste affichee sur sa couleur/pointure par defaut.
   Comportement demande : la pointure choisie doit rester visible/fixee sur
   les modeles affiches, comme le faisait l'ancien size-quick-filter.js avant
   la simplification du parcours d'achat (voir snippets/journey-selector.liquid).
   Fichier volontairement indépendant et minimal : ne s'occupe QUE de ce
   fixage visuel, ne touche a aucun filtrage (deja gere nativement). */
(function () {
  "use strict";

  function getSizeFromUrl() {
    return new URLSearchParams(window.location.search).get("filter.v.option.pointure");
  }

  function simulateRealClick(el) {
    ["pointerdown", "mousedown", "pointerup", "mouseup", "click"].forEach(function (type) {
      var ev = new MouseEvent(type, { bubbles: true, cancelable: true, view: window });
      el.dispatchEvent(ev);
    });
  }

  function findSizeSwatch(card, size) {
    var items = card.querySelectorAll(".swatch-view-item[orig-value]");
    var target = null;
    items.forEach(function (li) {
      if (target) return;
      if (li.classList.contains("swatch-item-unavailable")) return;
      if ((li.getAttribute("orig-value") || "") === size) target = li;
    });
    return target;
  }

  function preselectSize(size, attempt) {
    if (!size) return;
    attempt = attempt || 0;
    var cards = document.querySelectorAll(".product-grid__size-wrap");
    var pending = false;

    cards.forEach(function (card) {
      if (card.getAttribute("data-pointure-fixed") === size) return;

      var target = findSizeSwatch(card, size);
      if (!target) {
        pending = true;
        return;
      }

      if (target.getAttribute("aria-checked") === "true") {
        card.setAttribute("data-pointure-fixed", size);
        return;
      }

      simulateRealClick(target.querySelector(".swatch-button") || target);
      pending = true;
    });

    if (pending && attempt < 8) {
      setTimeout(function () {
        preselectSize(size, attempt + 1);
      }, 400);
    }
  }

  function run() {
    preselectSize(getSizeFromUrl());
  }

  document.addEventListener("DOMContentLoaded", function () {
    run();

    // Search & Discovery remplace .filters-adjacent (grille comprise) a
    // chaque clic sur un filtre classique (ajax) — nouvelles cartes, aucune
    // ne porte encore data-pointure-fixed : on reapplique dessus. Meme garde
    // deconnexion/reconnexion que l'ancien size-quick-filter.js pour eviter
    // qu'un clic simule ici (simulateRealClick) ne redeclenche cette meme
    // callback en boucle.
    var gridAdjacent = document.querySelector(".filters-adjacent") || document.querySelector(".product-grid");
    if (gridAdjacent) {
      var observer = new MutationObserver(function () {
        observer.disconnect();
        run();
        observer.observe(gridAdjacent, { childList: true, subtree: true });
      });
      observer.observe(gridAdjacent, { childList: true, subtree: true });
    }
  });
})();
